import React, { useState } from 'react';
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { useNavigate, useParams } from 'react-router-dom';
import * as svg from '@progress/kendo-svg-icons';
import { toast } from 'react-toastify';
import { PartialSpinny } from '../../../../Nav/Spinny';
import { UserApi } from '../../../../../redux/api/UserApi';
import { TicketApi } from '../../../../../redux/api/TicketApi';
import { IActionDTO } from '../../../../../types/Action/IAction';
import { PinApi } from '../../../../../redux/api/PinApi';
import { IPinItem } from '../../../../../types/Pin/IPinItem';

const DeleteDockItem: React.FC = () => {
    const { pinId } = useParams();
    const navigate = useNavigate();
    const { data: profile } = UserApi.useGetUserProfileQuery();
    //Get existing action
    const [unpin, { isLoading: deleting }] = PinApi.useDeletePinMutation();
    const [unpinAll, { isLoading: deletingAll }] = PinApi.useDeletePinsMutation();

    const handleClose = () => {
        navigate(-1);
    };

    const handleConfirm = () => {
        //Delete via API
        unpin({ Id: parseInt(pinId) } as IPinItem).unwrap().then(() => {
            //toast.success('Dock item removed');
            //Go Back
            navigate(-1);
        });
    };

    const handleConfirmAll = () => {
        //Delete via API
        unpinAll(null).unwrap().then(() => {
            //toast.success('Dock item removed');
            //Go Back
            navigate(-1);
        });
    };


    return (
        <>
            <Window modal={true} minimizeButton={() => null} maximizeButton={() => null} className='cool-window' title="Unpin?" onClose={handleClose} width={550} height={200}>
                {(deleting || deletingAll) && <PartialSpinny />}

                <>
                    <div>
                        <p>Do you want to remove only this {profile?.Phrases.CallPhrase} from the dock or remove all {profile?.Phrases.CallPhrase}s from the dock?</p>
                    </div>
                    <WindowActionsBar layout='center'>
                        <Button onClick={handleConfirm} svgIcon={svg.trashIcon} style={{ width: '150px', color: '#fff', background: profile?.Nav_Hex_Color }}>
                            Remove
                        </Button>
                        <Button onClick={handleConfirmAll} svgIcon={svg.trashIcon} style={{ width: '150px', color: '#fff', background: profile?.Nav_Hex_Color }}>
                            Remove All
                        </Button>
                        <Button fillMode='outline' onClick={handleClose}>Cancel</Button>
                    </WindowActionsBar></>

            </Window></>
    );
};

export default DeleteDockItem;